/**
 * Lessons Types
 */
export const APPEND_LESSONS = "APPEND_LESSONS";
export const LESSONES_RECEIVED = "LESSONES_RECEIVED";
export const SET_PROPERTY_LESSON = "SET_PROPERTY_LESSON";
export const SET_LESSON = "SET_LESSON";
export const CREATE_LESSON = "CREATE_LESSON";
export const AGREGAR_MULTIMEDIA = "AGREGAR_MULTIMEDIA";
export const AGREGAR_DESCARGABLE = "AGREGAR_DESCARGABLE";
export const SET_ARCHIVO_MULTIMEDIA = "SET_ARCHIVO_MULTIMEDIA";
export const SET_PROPERTY_MULTIMEDIA = "SET_PROPERTY_MULTIMEDIA";
export const SET_ARCHIVO_DESCARGABLE = "SET_ARCHIVO_DESCARGABLE";
export const SET_PROPERTY_DESCARGABLE = "SET_PROPERTY_DESCARGABLE";
export const ELIMINAR_MULTMEDIA = "ELIMINAR_MULTMEDIA";
export const ELIMINAR_DESCARGABLE = "ELIMINAR_DESCARGABLE";
export const SET_LESSON_MEDIA = "SET_LESSON_MEDIA";
export const SET_LESSON_TEST = "SET_LESSON_TEST";
